var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header',{staticClass:"header"}),_c('HomePageOne'),_c('RemittanceServicePage'),_c('CarouselPage'),_c('PaymentPartnersPage'),_c('CashbackPage'),_c('CrossBorderCardPage'),_c('GifeCardPage'),_c('IntroducePage'),_c('LeadershipCarousel'),_c('NewsPage'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }